/**
 * 通用首页头部组件
 */
import React from 'react'
import './index.less'
import { CommonHomeHeaderModel } from '@/controller/global/InitHeader'
import DFImage from '../../DFImage'
const CommonHomeHeadPart = (props: CommonHomeHeaderModel) => {
  const changeDiv = (url?: string) => {
    if (url) {
      window.df_sdk_common.location.href = url
    }
  }

  return (
    <div className="header-part">
      <div>
        {props?.leftHomeIcon && props?.leftHomeShow && (
          <div
            className="home-icon"
            onClick={() => {
              changeDiv(props?.leftHomeUrl)
            }}
          >
            <DFImage src={props?.leftHomeIcon} />
            <div>{props?.leftHomeText}</div>
          </div>
        )}
        {props?.leftLogoIcon && props?.leftLogoShow && (
          <div className="logo-icon">
            <DFImage src={props?.leftLogoUrl} />
          </div>
        )}
        {props?.rightCityShow && (
          <div
            className="city-text"
            onClick={() => {
              props?.rightCityClick?.()
            }}
          >
            <div>{props?.rightCityText}</div>
            <DFImage src="http://oss-dffl-ops.dongfangfuli.com/prd/fore-cms-h5/pagesite/images/down-80c3.png" />
          </div>
        )}
      </div>
      <div style={{ justifyContent: 'flex-end' }}>
        {props?.rightSearchShow && props?.rightSearchIcon && (
          <div
            className="search-icon"
            onClick={() => {
              changeDiv(props?.rightSearchUrl)
            }}
          >
            <DFImage src={props?.rightSearchIcon} />
            <div>{props?.rightSearchText}</div>
          </div>
        )}
        {props?.rightServiceShow && props?.rightServiceIcon && (
          <div
            className="service-icon"
            onClick={() => {
              props?.rightServiceClick?.()
            }}
          >
            <DFImage src={props?.rightServiceIcon} />
            <div>{props?.rightServiceText}</div>
          </div>
        )}
        {props?.rightMenusShow && props?.rightMenusIcon && (
          <div
            className="menus-icon"
            onClick={() => {
              props?.rightMenusClick?.()
            }}
          >
            <DFImage src={props?.rightMenusIcon} />
            <div>{props?.rightMenusText}</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CommonHomeHeadPart
